export let ENV: { OPTIMIZELY_KEY: string; LOG_METHOD: string; LOG_LEVEL: null };
ENV = {
  OPTIMIZELY_KEY: 'HdBuvi9mYtLrRsEhhZe1q',
  LOG_METHOD: 'setLogger',
  LOG_LEVEL: null,
};
